<template>
    <div class="top-container">
        <div class="col">
            <div class="images">
                <img v-if="image !== null" :src="image" alt="Header Aviation Image" />
                <img :src="golf" alt="Golf" />
            </div>
            <div class="page-title" v-if="!isHomepage">{{ pageTitle }}</div>
            <div class="call-to-action" v-if="callToActionText.length > 0">
                <div class="call-to-action-text" v-html="callToActionText"></div>
                <div class="btn call-to-action-btn btn-zoom">
                  <a :href="callToActionUrl">
                    {{ callToActionBtnText }}
                  </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'TopContainer',
  data () {
    return {
      golf: require('@/assets/golf.png')
    }
  },
  props: {
    image: {
      type: String,
      required: false,
      default: '/img/top.jpg'
    },
    isHomepage: {
      type: Boolean,
      required: false,
      default: false
    },
    pageTitle: {
      type: String,
      required: false,
      default: 'Title here'
    },
    callToActionText: {
      type: String,
      required: false,
      default: ''
    },
    callToActionUrl: {
      type: String,
      required: false,
      default: '#'
    },
    callToActionBtnText: {
      type: String,
      required: false,
      default: 'Meld je aan voor de selectie'
    }
  }
}
</script>

<style scoped>
.page-title {
  position: absolute;
  z-index: 4;
  width: calc(50%);
  text-align: left;
  vertical-align: center;
  top: 20px;
  left: 20px;
  color: #fff;
  font-size: 45px;
  font-weight: normal;
  text-transform: uppercase;
}

.call-to-action-btn a {
  color: #fff;
  text-decoration: none;
}

.btn {
  height: 1rem;
  padding: 4px 15px 22px 15px;
}

.call-to-action-btn {
  font-size: 13px;
  background-color: rgba(206, 94, 49, 0.5);
  color: #fff;
  border-radius: 20px;
  width: auto;
}

.top-container {
  position: relative;
  max-width: 1366px;
  max-height: 394px;
  width: auto;
  height: auto;
  margin: 0px;
  padding: 0px;
}

.top-container .col {
  width: 100%;
  height: auto;
  max-height: 394px;
  margin: 0px;
  padding: 0px;
}

.top-container .col .images {
  z-index: 0;
}

.top-container .col .images img:nth-child(1) {
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: auto;
  object-fit: cover;
  z-index: 0;
}

.top-container .col .images img:nth-child(2) {
  position: absolute;
  max-width: 1366px;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  z-index: 1;
}

.top-container .col .call-to-action {
  position: absolute;
  z-index: 4;
  width: calc(25%);
  text-align: right;
  vertical-align: center;
  top: 20px;
  right: 20px;
}

.top-container .col .call-to-action .call-to-action-text {
  font-size: 40px;
  color: #fff;
  font-family: "Roboto", sans-serif;
  line-height: 45px;
  text-transform: uppercase;
}

.top-container .col .call-to-action .call-to-action-btn {
  font-size: 13px;
  background-color: #ce5e31;
  color: #fff;
  border-radius: 20px;
  width: auto;
}

/* Small devices (landscape phones, 576px and up) */
@media (max-width: 576px) {
  .top-container .col .call-to-action {
    display: none;
  }

  .page-title {
    color: #000;
    top: 60px;
    font-size: 20px;
    left: 10px;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
  .top-container .col .call-to-action {
    display: none;
  }

  .page-title {
    color: #000;
    top: 80px;
    font-size: 20px;
    max-width: 200px;
    word-wrap: break-word;
  }
}

/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
@media (min-width: 768px) {
  .top-container .col .call-to-action {
    display: inline-block;
    top: 0px;
    margin-right: 20px;
    width: 30%;
  }

  .top-container .col .call-to-action .call-to-action-text {
    padding-top: 20px;
    line-height: 35px;
    font-size: 30px;
  }

  .page-title {
    color: #fff;
    top: 10px;
    font-size: 30px;
    left: 20px;
    max-width: initial;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .top-container .col .call-to-action {
    display: inline-block;
    top: 0px;
  }

  .top-container .col .call-to-action .call-to-action-text {
    font-size: 40px;
    padding-top: 40px;
    line-height: 45px;
  }

  .page-title {
    color: #fff;
    top: 20px;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .top-container .col .call-to-action {
    display: inline-block;
    top: 0px;
  }

  .top-container .col .call-to-action .call-to-action-text {
    padding-top: 60px;
    font-size: 45px;
    line-height: 50px;
  }

  .page-title {
    color: #fff;
    top: 30px;
  }
}
</style>
